/**
 * Theme Requirements Aggregation for Amc Preferred Theme
 * 
 * Extends the base preferred theme requirements with Amc Preferred Theme specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-preferred/requirements';

/**
 * Amc Preferred Theme component requirement overrides.
 * Add requirements for any override components here.
 */
const amcpreferredthemeOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Amc Preferred Theme theme.
 * Inherits from preferred theme and overrides with Amc Preferred Theme components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...amcpreferredthemeOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
